import { FREE_COLUMN_FILTER_TYPES } from '@/coreDomainsModule/constants';
import { FilterContentItem, FreeColumnFilterContentItem, isFreeColumnFilterType } from './filterModal';

/**
 * Preferenceへ保存する自由欄フィルター
 */
type StoredFreeColumnFilterItem = {
  columnIndex: number;
  selectedValue: string[];
};

/**
 * Preferenceから取得した値が自由欄フィルター形式か判定する
 * @param value - 判定対象
 */
const isStoredFreeColumnFilterItem = (value: unknown): value is StoredFreeColumnFilterItem => {
  if (typeof value !== 'object' || value === null) return false;
  const item = value as Partial<StoredFreeColumnFilterItem>;
  return (
    typeof item.columnIndex === 'number' &&
    Array.isArray(item.selectedValue) &&
    item.selectedValue.every((selected) => typeof selected === 'string')
  );
};

/**
 * 自由欄フィルターを既存のテーブルフィルターPreferenceへ保存できる形式に変換する。
 * NOTE: FilterModal周りを再設計するまでの暫定的なシリアライズ形式。
 * @param items - 自由欄フィルター
 */
export const encodeFreeColumnFilterItems = (items: FreeColumnFilterContentItem[]): FilterContentItem[] => {
  return FREE_COLUMN_FILTER_TYPES.flatMap((filterType) => {
    const storedItems: StoredFreeColumnFilterItem[] = items
      .filter((item) => item.filterType === filterType && item.selectedValue.length > 0)
      .map((item) => ({
        columnIndex: item.columnIndex,
        selectedValue: [...item.selectedValue],
      }));

    if (storedItems.length === 0) return [];

    return [
      {
        filterType,
        selectedValue: [JSON.stringify(storedItems)],
        label: '',
      },
    ];
  });
};

/**
 * Preferenceから取得した自由欄フィルターをFilterModal用の形式へ戻す。
 * @param items - Preferenceから取得したフィルター
 */
export const decodeFreeColumnFilterItems = (items: FilterContentItem[]): FreeColumnFilterContentItem[] => {
  return items.flatMap((item) => {
    if (!isFreeColumnFilterType(item.filterType)) return [];

    const serialized = item.selectedValue[0];
    if (!serialized) return [];

    try {
      const parsed: unknown = JSON.parse(serialized);
      if (!Array.isArray(parsed) || !parsed.every(isStoredFreeColumnFilterItem)) {
        console.error('自由欄フィルターのPreference形式が不正です。', parsed);
        return [];
      }

      return parsed.map((storedItem) => ({
        filterType: item.filterType,
        columnIndex: storedItem.columnIndex,
        selectedValue: [...storedItem.selectedValue],
        label: '',
      }));
    } catch (error) {
      console.error('自由欄フィルターのPreferenceを復元できませんでした。', error);
      return [];
    }
  });
};
